import { IonDate } from "./../i-components/IonDate.tsx";

const CheckNotNull = Symbol('CheckNotNull'); 

class Payment {
    public paymentID: string = '';
    public invoice_no: string = '';
    public type: number = 0;
    public status: number = 0;
    public contact_salutation: number = 0;
    public contact_other_salutation: string = '';
    public contact_name: string = '';
    public contact_hp: string = '';
    public contact_office_no: string = '';
    public contact_email: string = '';
    public billing_name: string = '';
    public billing_address: string = '';
    public e_invoice_pin: string = '';
    public itemIDs: string[] = [] as string[];
    public pax: number = 0;
    public amounts: number[] = [] as number[];
    public datetime_created: Date | null = null;
    public datetime_updated: Date | null = null;
    public remarks: string = '';

    constructor(
        paymentID: string,
        invoice_no: string,
        type: string,
        status: string,
        contact_salutation: string,
        contact_other_salutation: string,
        contact_name: string,
        contact_hp: string,
        contact_office_no: string,
        contact_email: string,
        billing_name: string,
        billing_address: string,
        e_invoice_pin: string,
        itemIDs: string,
        pax: string,
        amounts: string,
        datetime_created: string,
        datetime_updated: string,
        remarks: string
    ) {
        this.paymentID = this[CheckNotNull](paymentID) ? paymentID : '';
        this.invoice_no = this[CheckNotNull](invoice_no) ? invoice_no : '';
        this.type = this[CheckNotNull](type) ? parseInt(type) : 0;
        this.status = this[CheckNotNull](status) ? parseInt(status) : 0;
        this.contact_salutation = this[CheckNotNull](contact_salutation) ? parseInt(contact_salutation) : 0;
        this.contact_other_salutation = this[CheckNotNull](contact_other_salutation) ? contact_other_salutation : '';
        this.contact_name = this[CheckNotNull](contact_name) ? contact_name : '';
        this.contact_hp = this[CheckNotNull](contact_hp) ? contact_hp : '';
        this.contact_office_no = this[CheckNotNull](contact_office_no) ? contact_office_no : '';
        this.contact_email = this[CheckNotNull](contact_email) ? contact_email : '';
        this.billing_name = this[CheckNotNull](billing_name) ? billing_name : '';
        this.billing_address = this[CheckNotNull](billing_address) ? billing_address : '';
        this.e_invoice_pin = this[CheckNotNull](e_invoice_pin) ? e_invoice_pin : '';
        this.itemIDs = this[CheckNotNull](itemIDs) ? itemIDs.split(',') : [];
        this.pax = this[CheckNotNull](pax) ? parseInt(pax) : 0;
        this.amounts = this[CheckNotNull](amounts) ? amounts.split(',').map((amount: string) => parseFloat(amount)) : [];
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
        this.datetime_updated = this[CheckNotNull](datetime_updated) ? IonDate(datetime_updated) : null;
        this.remarks = this[CheckNotNull](remarks) ? remarks : '';
    }

    //privates
    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0) 
            return true;
        else
            return false;
    }
}
export default Payment;